/* global trapFocus, removeTrapFocus */

class DetailsModal extends HTMLElement {
  constructor() {
    super()

    this.onOpenToggle = this.onOpenToggle.bind(this)
    this.onBodyClick = this.onBodyClick.bind(this)
    this.onKeyUp = this.onKeyUp.bind(this)

    this.openButtons = Array.from(this.querySelectorAll('[data-modal-open]'))
    this.closeButtons = Array.from(this.querySelectorAll('[data-modal-close]'))
    this.modalContainer = this.querySelector('[data-modal-content]')
    this.overlay = this.modalContainer?.querySelector('.modal-overlay')

    this.openButtons.forEach((button) => {
      button.type = 'button'
      // button.setAttribute('aria-expanded', 'false')
      // this.ensureAriaControls(button)
      button.addEventListener('click', this.onOpenToggle)
    })

    this.closeButtons.forEach((button) => {
      button.type = 'button'
      button.addEventListener('click', () => this.close())
    })

    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.close())
    }

    if (this.modalContainer) {
      this.modalContainer.setAttribute('aria-hidden', 'true')
      this.modalContainer.setAttribute('hidden', '')
      this.modalContainer.addEventListener('keyup', this.onKeyUp)
    }
  }

  isOpen() {
    return this.hasAttribute('open')
  }

  onOpenToggle(event) {
    event.preventDefault()
    const trigger = event.currentTarget
    if (this.isOpen()) {
      this.close()
    } else {
      this.open(trigger)
    }
  }

  onBodyClick(event) {
    if (!this.contains(event.target)) this.close(false)
  }

  open(trigger) {
    this.activeTrigger = trigger
    this.setAttribute('open', '')
    this.toggleAriaExpanded(true)

    if (this.modalContainer) {
      this.modalContainer.removeAttribute('hidden')
      this.modalContainer.setAttribute('aria-hidden', 'false')
    }

    document.body.addEventListener('click', this.onBodyClick, true)
    document.body.classList.add('overflow-hidden')

    const focusContainer =
      this.modalContainer?.querySelector('[tabindex="-1"]') ||
      this.modalContainer
    const firstInput = this.modalContainer?.querySelector(
      'input:not([type="hidden"])',
    )

    if (focusContainer) {
      trapFocus(focusContainer, firstInput)
    }
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.activeTrigger || null : null)
    this.removeAttribute('open')
    this.toggleAriaExpanded(false)

    if (this.modalContainer) {
      this.modalContainer.setAttribute('aria-hidden', 'true')
      this.modalContainer.setAttribute('hidden', '')
    }

    document.body.removeEventListener('click', this.onBodyClick, true)
    document.body.classList.remove('overflow-hidden')
    this.activeTrigger = null
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() === 'ESCAPE') {
      this.close()
    }
  }

  toggleAriaExpanded(isOpen) {
    this.openButtons.forEach((button) => {
      button.setAttribute('aria-expanded', String(isOpen))
    })
  }

  // ensureAriaControls(button) {
  //   if (!this.modalContainer) return

  //   if (!this.modalContainer.id) {
  //     this.modalContainer.id = DetailsModal.generateId()
  //   }

  //   button.setAttribute('aria-controls', this.modalContainer.id)
  // }
}

DetailsModal.generateId = (() => {
  let id = 0
  return () => {
    id += 1
    return `details-modal-${id}`
  }
})()

customElements.define('details-modal', DetailsModal)
